var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallPhone = function SvgSmallPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#717888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.037 6.325c.58 1.208 1.37 2.34 2.372 3.342a12.2 12.2 0 0 0 3.342 2.372c.104.05.156.074.221.094.234.068.52.019.719-.123.055-.04.103-.087.198-.183.292-.291.437-.437.584-.532a1.67 1.67 0 0 1 1.817 0c.146.095.292.241.583.532l.163.163c.442.443.664.664.784.902.24.473.24 1.031 0 1.504-.12.238-.341.46-.784.902l-.132.132c-.441.441-.662.662-.962.83-.333.187-.85.322-1.232.32-.344 0-.579-.067-1.05-.2a15.87 15.87 0 0 1-6.902-4.062 15.87 15.87 0 0 1-4.062-6.903c-.133-.47-.2-.705-.2-1.05a2.8 2.8 0 0 1 .32-1.231c.168-.3.389-.521.83-.962l.131-.132c.443-.443.665-.664.903-.784a1.67 1.67 0 0 1 1.504 0c.238.12.46.341.902.784l.163.163c.29.29.437.437.532.583.359.552.359 1.265 0 1.817-.095.147-.241.292-.532.584-.096.095-.143.142-.183.198a.87.87 0 0 0-.123.718c.02.066.044.118.094.222"
  })));
};
export default SvgSmallPhone;